// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"151":"b194fd7d","225":"9de2e369","356":"9de2e369","601":"9de2e369","982":"767539f4"}[chunkId] + ".chunk.css";
};